import * as S from './styles'
import { useTextHome } from './useTextHomeContainer'
import { Text } from '@/components'
import { TextHome } from '@/service/api/home'

export type TextHomeContainerProps = {
  data: TextHome
  isVisible: boolean
}
export const TextHomeContainer = ({
  data,
  isVisible,
}: TextHomeContainerProps) => {
  const { fontSizes } = useTextHome()

  if (!data.topics.length) return null
  return (
    <S.TextHomeContainer isVisible={isVisible}>
      <div className="topics">
        {data.topics.map((topic) => (
          <div key={topic.title} className="topic">
            <Text color="darkgray" size={fontSizes.title}>
              {topic.title}
            </Text>
            <Text color="darkgray" size={fontSizes.description}>
              {topic.description}
            </Text>
          </div>
        ))}
      </div>
    </S.TextHomeContainer>
  )
}
